// Messages between the operator console and the patient display window (same origin).

import type { ResponseKey } from "../lib/protocol";

export type ConsoleToDisplay =
  | { type: "hello" }
  | { type: "run"; testId: number }
  | { type: "abort" }
  | { type: "response"; key: ResponseKey; epochMs: number };

export type DisplayToConsole =
  | { type: "ready"; fullscreen: boolean; screen: string; float16: boolean }
  | { type: "progress"; testId: number; seq: number; phase: string; value: number; correct: boolean; label: string }
  | { type: "test-done"; testId: number; status: string }
  | { type: "error"; testId?: number; message: string }
  | { type: "sink"; pending: number; error: string | null };

export function sessionChannel(sessionId: number): BroadcastChannel {
  return new BroadcastChannel(`vtlite-session-${sessionId}`);
}
